import React, {Component} from 'react';
import _ from 'lodash';

import SimpleModal from './SimpleModal';

export default class MultipleUpload extends Component {
  constructor(props){
    super(props)

    this.state = {
      open: false,
      files: [
        {
          file: '',
          file_name: ''
        }
      ]
    }

    this.onClose = this.onClose.bind(this);
    this.renderFile = this.renderFile.bind(this);
    this.handleSetValue = this.handleSetValue.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
  }

  handleChangeFile(event){
    var file = event.target.files[0];
    if (file.size === 0) { return }
    if (file.size > 16000000) { 
      alert("ขนาดไฟล์ต้องไม่เกิน 15 MB.");
      return
    }

    var index = _.size(this.state.files);
    index = index - 1;

    let { files } = this.state;
    files[index].file = file;
    files[index].file_name = file.name;
    files = _.concat(files, {file: '', file_name: ''});

    this.setState({
      open: true,
      files: files
    });

    event.target.value = '';
  }

  onClose(){
    this.setState({open: false});
  }

  renderFile(file, index){
    if (_.isEmpty(file.file_name)) { return }
    return (
      <div key={index} className='col-12'>
        {file.file_name}
      </div>
    )
  }

  handleSetValue(){
    this.setState({
      open: false,
      files: [
        {
          file: '',
          file_name: ''
        }
      ]
    }, this.props.onChange(this.state.files));
  }

  render(){
    return (
      <div>
        <div>
          <label className="btn btn-sm btn-success pointer mb-0 mr-2">
              <i className="fa fa-upload mr-1" aria-hidden="true"></i>
                {this.props.label}
                <input 
                  type="file" 
                  name='file' 
                  hidden
                  onChange={this.handleChangeFile} />
            </label>
            <label className='text-danger'>{this.props.limitation_label}</label>
        </div>

        <SimpleModal 
          isOpen={this.state.open}
          title={'อัพโหลดไฟล์'}
          showSubmitButton={false}
          onClose={this.onClose}>
          <div>
            <div className='row form-group'>
              <div className='col-md-12 form-group'>
                {this.props.notice_label}
              </div>
              <div className='col-md-12 form-group'>
                <div>
                  <label className="btn btn-sm btn-success pointer mb-0 mr-2">
                    <i className="fa fa-upload mr-1" aria-hidden="true"></i>
                    เลือกไฟล์เพิ่ม
                    <input 
                      type="file"
                      name='additional_file' 
                      hidden
                      onChange={this.handleChangeFile} />
                  </label>
                </div>
              </div>
              <div className='col-md-12 form-group bg-faded'>
                <div className='row'>
                  {this.state.files && _.map(this.state.files, this.renderFile)}
                </div>
              </div>
            </div>
            <div className="modal-footer row">
              <button 
                type='button' 
                className="btn btn-primary pointer"
                onClick={this.handleSetValue}>อัพโหลด</button>
              <button type='button' className="btn btn-secondary pointer" onClick={this.onClose}>ยกเลิก</button>
            </div>
          </div>
        </SimpleModal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/MultipleUpload.js